<template>
  <app-content>
    <app-content-body>
      <div class="inner">
          <StatisticOverlay v-if="this.isStatisticOverlayOpened"
              @close="_closeStatisticOverlay"
          />

          <p class="buttons">
              <a class="btn btn_action btn_grey btn_epg_plus"
                 @click.stop="_openStatisticOverlay" :title="$gettext('Stav zpracování EPG+')" v-translate>Stav zpracování EPG+</a>
          </p>

        <h1 v-translate>Zpracování EPG</h1>
      </div>

      <app-table
          clickable
          :selectable="controlsAllowed"
          :data="items"
          :selected-rows="checkedRows"
          :order="params.order"
          :page-size="params.limit"
          :loading="pending"
          @sort="sortItems"
          @rowClick="goToBroadcastDetail"
          @rowSelect="selectRow"
      >
        <template slot="header">
          <app-table-header-item class="field_left">
            <app-input
                type="search"
                :label="translations.search"
                v-model="params.search"
                @input="filterBroadcasts()"
            />
            <app-checkbox
                name="fulltextSearch"
                title="Zpřísnit kritéria vyhledávání"
                v-model="fulltextSearch"
            />
          </app-table-header-item>

          <app-table-header-item class="field_right">
            <app-table-header-select :label="translations.createdBy">
              <app-select
                  id="createdBy"
                  :options="createdOptions"
                  selectId="createdSelect"
                  name="createdSelect"
                  v-model="createdSelect"
              />
            </app-table-header-select>
          </app-table-header-item>

          <app-table-header-item class="field_left">
            <app-input
                type="search"
                :label="translations.episodeName"
                v-model="params.episodeName"
                @input="filterBroadcasts()"
            />
          </app-table-header-item>

            <app-table-header-item class="field_right">
                <app-table-header-select :label="translations.from">
                    <app-date-since
                        :currentTimestamp="currentTimestamp"
                        :start-date="pickerStartDate"
                        :end-date="pickerEndDate"
                        @dateChanged="onDateChanged"
                        @hourChanged="onHourChanged"
                        @resetTime="resetTime"
                    />
                </app-table-header-select>
            </app-table-header-item>

          <app-table-header-item class="field_left">
            <div class="field field_search">
              <label for="skupinyStanic">Skupiny stanic</label>
              <select name="skupinyStanic" id="skupinyStanic" v-model="selectedTvStationGroup" @change="this.onTvStationGroupSelected">
                <option value="all">Všechny</option>
                <option value="epgPlus">EPG plus</option>
                <option value="epgRest">EPG rest</option>
                <option
                  v-for="tvStationGroup in tvStationGroups"
                  :key="tvStationGroup._id"
                  v-bind:value="tvStationGroup._id"
                >
                  {{ tvStationGroup.name }}
                </option>
              </select>
            </div>
          </app-table-header-item>

            <app-table-header-item class="field_right">
                <app-table-header-select :label="translations.to">
                    <app-date-since
                        :currentTimestamp="currentToTimestamp"
                        :start-date="pickerStartDate"
                        :end-date="pickerEndDate"
                        :reset-time-string="'Příští neděle'"
                        @dateChanged="onToDateChanged"
                        @hourChanged="onToHourChanged"
                        @resetTime="resetToTime"
                    />
                </app-table-header-select>
            </app-table-header-item>


            <dropdown-input
              label="Stanice"
              :options="tvStationAutocompleteData"
              :selected="selectedTvStations.map(selectedTvStation => this.getTvStationLabelText(selectedTvStation))"
              :visibleResultLimit="10"
              @seeMoreClicked="seeAllTvStations"
              @autocompleteValueChanged="onTvStationSelected"
              @removeItem="removeTvStation"
              @removeAll="removeAllTvStations"
            />

            <div class="field_left field_full">
              <p class="field checkbox_label">Formát</p>
              <div class="field checkboxes">
                <p class="field" v-for="label in labelsTypeFormat" :key="label._id">
                  <input
                    :id="'format' + label._id"
                    :name="'format' + label._id"
                    v-model="formatLabelsState[label._id].checked"
                    type="checkbox"
                    :value="label._id"
                    @change="onFormatChange"
                  >
                  <label :for="'format' + label._id">{{label.labelName}}</label>
                </p>
              </div>
            </div>

            <app-table-header-item class="field_left field_full">
            <p class="field checkbox_label">Stav vysílání</p>
            <div class="field checkboxes">
              <p class="field">
                <app-checkbox
                    key="stavVysilani1"
                    name="stavVysilani1"
                    title="Vysílání navázaná na pořady"
                    :value="broadcastStateCheckbox1.checked"
                    :checked="broadcastStateCheckbox1.checked"
                    :tv-program-filtration="true"
                    :green="true"
                    @change="onBroadcastStateCheckboxChanged(broadcastStateCheckbox1, $event)"
                />
              </p>
              <p class="field">
                <app-checkbox
                    key="stavVysilani2"
                    name="stavVysilani2"
                    title="Vysílání navázaná na pořady, je třeba kontrola"
                    :value="broadcastStateCheckbox2.checked"
                    :checked="broadcastStateCheckbox2.checked"
                    :tv-program-filtration="true"
                    :orange="true"
                    @change="onBroadcastStateCheckboxChanged(broadcastStateCheckbox2, $event)"
                />
              </p>
              <p class="field">
                <app-checkbox
                    key="stavVysilani3"
                    name="stavVysilani3"
                    title="Vysílání navázaná na dočasné pořady"
                    :value="broadcastStateCheckbox3.checked"
                    :checked="broadcastStateCheckbox3.checked"
                    :tv-program-filtration="true"
                    :red="true"
                    @change="onBroadcastStateCheckboxChanged(broadcastStateCheckbox3, $event)"
                />
              </p>
            </div>
          </app-table-header-item>
        </template>

        <app-table-column sortable sort-name="state" class="state_th" :label="translations.status">
          <template slot-scope="row">
            <app-status-indicator :status="mapStatusToIndicator(row.state)" />
          </template>
        </app-table-column>
        <app-table-column sortable sort-name="name" :label="translations.name">
          <template slot-scope="row">
            <strong>
              <a
                  class="f_search"
                  title="Vyfiltrovat"
                  @click.prevent.stop="onFilterClick(row.name)"
              >Vyfiltrovat</a>
              <a>{{ row.name }}</a>
            </strong>
          </template>
        </app-table-column>
        <app-table-column sortable sort-name="episodeName" :label="translations.episodeName">
          <template slot-scope="row">
            <a>{{ row.episodeName }}</a>
          </template>
        </app-table-column>
        <app-table-column
            sortable
            sort-name="description"
            class="description_th"
            :label="translations.description"
        >
          <template slot-scope="row">
            <span>{{ _calculateRowDescription(row) }}</span>
          </template>
        </app-table-column>
        <app-table-column sortable sort-name="show" :label="translations.shows">
          <template slot-scope="row">
            <a
                v-if="row.show"
                title="Porad" @click.prevent.stop="onShowFilterClick(row.show._id)"
                class="link"
            >
              {{ row.show.name || row.show.originalName || row.show.firstTranslationName || '' }}
            </a>
            <span v-else></span>
          </template>
        </app-table-column>
        <app-table-column sortable sort-name="tvStation" :label="translations.tvStations">
          <template slot-scope="row">
            <a
              class="f_search"
              title="Vyfiltrovat"
              @click.prevent.stop="onTvStationFilterClick(row.tvStation._id)"
            >
              Vyfiltrovat
            </a>
            {{ row.tvStation.name }}
          </template>
        </app-table-column>
        <app-table-column sortable sort-name="start" :label="translations.start">
          <template slot-scope="row">
            <div v-html="formatDateEpg(row.start)" />
          </template>
        </app-table-column>
        <app-table-column
            sortable
            sort-name="durationMinutes"
            class="length_th"
            :label="translations.duration"
        >
          <template slot-scope="row">{{ row.durationMinutes }} min</template>
        </app-table-column>
        <app-table-column
            sortable
            sort-name="year"
            :label="translations.year"
        >
          <template slot-scope="row">
            {{ row.year }}
          </template>
        </app-table-column>

        <template slot="footer">
          <p class="check_all" v-if="controlsAllowed">
            <app-checkbox
                checkboxId="check-all"
                name="check-all"
                :checked="hasSelectedAll"
                @change="selectAll"
            />
            <app-select
                selectId="akce"
                name="akce"
                defaultFirstOption
                v-model="selectedFootbarAction"
                :options="actions"
            />
            <app-button @click="runFootbarAction" v-translate>Provést</app-button>
          </p>
          <app-table-pagination
              v-if="itemsMetadata.totalCount > params.limit"
              :page="listPage"
              :itemsPerPage="params.limit"
              :totalCount="itemsMetadata.totalCount"
              @pageChanged="tablePageChanged"
          />
        </template>
      </app-table>

      <assign-broadcasts
        v-if="assignBroadcastPopupShown"
        :broadcastIds="checkedRows"
        :broadcasts="checkedBroadcasts"
        @paired="filterBroadcasts(true)"
        @close="closesAssignBroadcastPopup"
      />

      <tv-station-filter-popup
        v-if="seeAllTvStationsShown"
        :tvStations="selectedTvStations"
        @tvStationsSelected="setSelectedTvStations"
        @close="closeSeeAllTvStations"
      />

    </app-content-body>
  </app-content>
</template>

<script>
import DropdownInput from 'components/DropdownInput'
import { mapActions, mapState } from 'vuex'
import getItemsListMixin from 'mixins/getItemsListMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import { AUTOCOMPLETE_TITLE } from 'symbols/autocomplete'
import AssignBroadcasts from './Broadcast/AssignBroadcasts.vue'
import TvStationFilterPopup from '../../components/Filter/TvStationFilterPopup.vue'
import moment from 'moment'
import StatisticOverlay from './StatisticOverlay'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'Epgs',
  enums: true,
  preventFetchOnCreated: true
})

export default {
  name: 'epgs',
  mixins: [formatDateMixin, itemsListMixin, appTitleMixin()],
  components: {
    DropdownInput,
    AssignBroadcasts,
    TvStationFilterPopup,
    StatisticOverlay
  },
  created() {
    this.params.generated = false

    if (this.params.tvStationGroup) {
      this.selectedTvStationGroup = this.params.tvStationGroup
    }

    if (this.params.createdBy) {
      this.createdSelect = this.params.createdBy
    }

    if (this.params.label) {
      this.params.label.split(',').forEach(labelId => {
        this.formatLabelsState[labelId] = {
          checked: true
        }
      })
    }
    if (this.params.fromTimestamp) {
      this.currentTimestamp = moment.unix(this.params.fromTimestamp)
    } else {
      this.currentTimestamp = moment()
    }
    if (this.params.toTimestamp) {
      this.currentToTimestamp = moment.unix(this.params.toTimestamp)
    } else {
      const curr = new Date()
      this.currentToTimestamp = moment(new Date(curr.setDate(curr.getDate() - curr.getDay() + 14)))
    }
    if (this.params.fulltextSearch !== undefined && this.params.fulltextSearch !== null) {
      this.fulltextSearch = this.params.fulltextSearch
    } else {
      this.fulltextSearch = true
    }

    this.getTvStationGroups({ params: { order: 'custom' } })
    this.getTvStations({ params: { order: 'name', countUnassignedBroadcasts: true, broadcastsFilter: this.params } })
    this.getLabels({ params: { idLanguage: this.currentLanguageId } })

    this.broadcastStateCheckbox1 = {
      checked: this.params.state.includes('BROADCAST_STATE_VERIFIED'),
      value: 'BROADCAST_STATE_VERIFIED'
    }
    this.broadcastStateCheckbox2 = {
      checked: this.params.state.includes('BROADCAST_STATE_UNVERIFIED'),
      value: 'BROADCAST_STATE_UNVERIFIED'
    }
    this.broadcastStateCheckbox3 = {
      checked: this.params.state.includes('BROADCAST_STATE_UNASSIGNED'),
      value: 'BROADCAST_STATE_UNASSIGNED'
    }

    this.filterBroadcasts(true)
  },
  data() {
    return {
      checkedRows: [],
      checkedBroadcasts: [],
      fetchTimeoutId: null,
      createdSelect: '',
      broadcastStateCheckbox1: null,
      broadcastStateCheckbox2: null,
      broadcastStateCheckbox3: null,
      selectedTvStationGroup: 'all',
      selectedTvStations: [],
      formatLabelsState: {},
      selectedFootbarAction: 'CONNECT_BROADCASTS',
      assignBroadcastPopupShown: false,
      seeAllTvStationsShown: false,
      currentTimestamp: null,
      currentToTimestamp: null,
      selectedAll: false,
      dataPending: false,
      fulltextSearch: null,
      window: null,
      isStatisticOverlayOpened: false
    }
  },
  computed: {
    ...mapState({
      briefOverview: state => state.broadcasts.broadcastOverview.briefOverview,
      broadcastOverview: state => state.broadcasts.broadcastOverview,
      labels: state => state.labels.labels,
      tvStationGroups: state => state.tvStationGroups.tvStationGroups,
      tvStations: state => state.tvStations.tvStations,
      currentLanguageId: state => state.uiLanguages.currentLanguageId
    }),
    createdOptions() {
      return [
        { name: this.translations.none, value: '' },
        { name: this.translations.automatically, value: 'AUTOMATICALLY' },
        { name: this.translations.manually, value: 'MANUALLY' }
      ]
    },
    pickerStartDate() {
      if (!this.broadcastOverview.groups) {
        return moment().toISOString()
      }
      return this.broadcastOverview.groups.find(v => v.groupType === 'archive').fromTimestamp
    },
    pickerEndDate() {
      if (!this.broadcastOverview.groups) {
        return moment().toISOString()
      }
      return this.broadcastOverview.groups.find(v => v.groupType === 'imported').toTimestamp
    },
    translations() {
      return {
        search: this.$gettext('Vyhledávání'),
        mode: this.$gettext('Režim'),
        status: this.$gettext('Stav'),
        name: this.$gettext('Název'),
        episodeName: this.$gettext('Název epizody'),
        year: this.$gettext('Rok'),
        description: this.$gettext('Popis'),
        start: this.$gettext('Začátek'),
        duration: this.$gettext('Délka'),
        tvStations: this.$gettext('TV stanice'),
        shows: this.$gettext('Pořad'),
        from: this.$gettext('Od'),
        to: this.$gettext('Do'),
        currentTime: this.$gettext('Aktuální čas'),
        createdBy: this.$gettext('Navázaný pořad vytvořen'),
        none: this.$gettext('Nevybráno'),
        automatically: this.$gettext('Automaticky'),
        manually: this.$gettext('Manuálně')
      }
    },
    hasSelectedAll() {
      return (
        this.checkedRows.length > 0 &&
          this.items.every(v => this.checkedRows.includes(v._id))
      )
    },
    actions() {
      const actions = [{ name: this.$gettext('Navázat vybraná vysílání'), value: 'CONNECT_BROADCASTS' }]

      this.checkedBroadcasts.forEach((broadcast) => {
        if (broadcast.show !== null && actions.length == 1) {
          actions.push({ name: this.$gettext('Zrušit navázání'), value: 'DISCONNECT_BROADCASTS' })
        }
      })

      return actions
    },
    currentTitle() {
      return [this.$gettext('Zpracování EPG')]
    },
    tvStationAutocompleteData() {
      return this.tvStations.reduce((result, tvStation) => {
        let accept = false
        if (!this.selectedTvStations.includes(tvStation)) {
          if (this.selectedTvStationGroup == 'all') {
            accept = true
          } else if (this.selectedTvStationGroup == 'epgPlus') {
            accept = (tvStation.type == 'TV_STATION_EPG_PLUS')
          } else if (this.selectedTvStationGroup == 'epgRest') {
            accept = (tvStation.type == 'TV_STATION_EPG_REST')
          } else {
            accept = tvStation.tvStationGroupIds.includes(this.selectedTvStationGroup)
          }

          if (accept) {
            tvStation[AUTOCOMPLETE_TITLE] = this.getTvStationLabelText(tvStation)

            result.push(tvStation)
          }
        }

        return result
      }, [])
    },
    labelsTypeFormat() {
      const formatLabels = this.labels.reduce((result, label) => {
        if (label.type == 'LABEL_TYPE_FORMAT') {
          result.push(label)
        }

        return result
      }, [])

      formatLabels.forEach(label => {
        if (this.formatLabelsState[label._id] == undefined) {
          this.formatLabelsState[label._id] = {
            checked: false
          }
        }
      })

      return formatLabels
    },
    controlsAllowed() {
      return this.params.search.length > 0
    }
  },
  methods: {
    ...mapActions(['getLabels', 'getTvStationGroups', 'getTvStations', 'deleteBroadcast']),
    _openStatisticOverlay() {
      this.isStatisticOverlayOpened = true
    },
    _closeStatisticOverlay() {
      this.isStatisticOverlayOpened = false
    },
    selectRow(row, checked) {
      if (checked) {
        this.checkedRows.push(row._id)
        this.checkedBroadcasts.push(row)
      } else {
        const index = this.checkedRows.indexOf(row._id)
        if (index !== -1) {
          this.checkedRows.splice(index, 1)
        }

        let indexBroadcast = -1
        this.checkedBroadcasts.forEach(function (item, index) {
          if (item._id === row._id) {
            indexBroadcast = index
          }
        })
        if (indexBroadcast !== -1) {
          this.checkedBroadcasts.splice(indexBroadcast, 1)
        }
      }
    },
    _calculateRowDescription(row) {
      const description = row.descriptionShort
        ? row.descriptionShort
        : row.descriptionLong;

        return description ? (description.length > 128
                ? description.substring(0, 128) + "..."
                : description)
            : "";
    },
    resetTime() {
      this.currentTimestamp = moment()
    },
    onDateChanged(date) {
      const tempHours = this.currentTimestamp.hours()
      this.currentTimestamp = moment(date).hours(tempHours)
    },
    onHourChanged(hour) {
      this.currentTimestamp = this.currentTimestamp.clone().hours(hour)
    },
    resetToTime() {
      const curr = new Date()
      this.currentToTimestamp = moment(new Date(curr.setDate(curr.getDate() - curr.getDay() + 14)))
    },
    onToDateChanged(date) {
      const tempHours = this.currentToTimestamp.hours()
      this.currentToTimestamp = moment(date).hours(tempHours)
    },
    onToHourChanged(hour) {
      this.currentToTimestamp = this.currentToTimestamp.clone().hours(hour)
    },
    selectAll(checked) {
      if (checked) {
        this.items.forEach(v => {
          if (this.checkedRows.indexOf(v._id) === -1) {
            this.checkedRows.push(v._id)
            this.checkedBroadcasts.push(v)
          }
        })
      } else {
        this.checkedRows = []
        this.checkedBroadcasts = []
      }
    },
    mapStatusToIndicator(status) {
      switch (status) {
        case 'BROADCAST_STATE_UNASSIGNED':
          return 'red'
        case 'BROADCAST_STATE_UNVERIFIED':
          return 'orange'
        case 'BROADCAST_STATE_VERIFIED':
          return 'green'
        default:
          return 'pending'
      }
    },
    onFilterClick(name) {
      this.params.search = name
      this.filterBroadcasts()
      this.selectedAll = true
    },
    onTvStationFilterClick(tvStationId) {
      const tvStation = this.tvStations.find(tvStationElement => tvStationElement._id == tvStationId)

      if (tvStation) {
        this.selectedTvStations = [tvStation]
        this.params.tvStations = this.getTvStationRequestFilter()
        this.filterBroadcasts()
      }
    },
    onShowFilterClick(showId) {
      const routeData = this.$router.resolve({
        name: 'show',
        params: { id: showId }
      })

      if (this.window) {
        this.window.close()
      }
      this.window = window.open(routeData.href, '_blank')
    },
    runFootbarAction() {
      if (this.selectedFootbarAction == 'CONNECT_BROADCASTS') {
        if (this.checkedRows.length > 0) {
          this.assignBroadcastPopupShown = true
        }
      } else if (this.selectedFootbarAction == 'DISCONNECT_BROADCASTS') {
        this.deleteBroadcast({ params: { id: this.checkedRows.join(',') } }).then(this.filterBroadcasts)
      }
      this.selectedFootbarAction = 'CONNECT_BROADCASTS'
    },
    goToBroadcastDetail(broadcast) {
      this.$router.push({
        name: 'broadcast',
        params: {
          id: broadcast._id
        }
      })
    },
    setFetchTimeout() {
      clearTimeout(this.fetchTimeoutId)
      this.fetchTimeoutId = setTimeout(() => this.filterBroadcasts(), 500)
    },
    async filterBroadcasts(created = false) {
      if (created) {
        this.dataPending = true
        const result = await this.fetchItems().then((res) => {
          this.dataPending = false
        })
      } else if (this.dataPending) {

      } else {
        this.getTvStations({ params: { order: 'name', countUnassignedBroadcasts: true, broadcastsFilter: this.params } })
        this.fetchItems(true)
        this.tablePageChanged(1, false)
      }
    },
    tablePageChanged(page, fetchItems = true) {
      window.scrollTo(0, 0)
      this.listPage = page
      this.params.offset = (this.listPage - 1) * this.params.limit
      if (fetchItems) {
        this.fetchItems()
      }
      this.checkedRows = []
      this.checkedBroadcasts = []
    },
    getTvStationLabelText(tvStation) {
      return tvStation.name + ' (' + tvStation.broadcastsCount + ')'
    },
    getTvStationRequestFilter() {
      return this.selectedTvStations.map(tvStation => tvStation._id).join(',')
    },
    onTvStationGroupSelected(event) {
      if (this.selectedTvStationGroup !== 'all') {
        this.params.tvStationGroup = this.selectedTvStationGroup
      } else {
        this.params.tvStationGroup = null
      }
      this.filterBroadcasts()
    },
    onTvStationSelected(tvStationId, tvStation) {
      this.selectedTvStations.push(tvStation)
      this.params.tvStations = this.getTvStationRequestFilter()
      this.filterBroadcasts()
    },
    removeTvStation(tvStationLabel) {
      this.selectedTvStations = this.selectedTvStations.filter(tvStation => this.getTvStationLabelText(tvStation) !== tvStationLabel)
      this.params.tvStations = this.getTvStationRequestFilter()
      this.filterBroadcasts()
    },
    removeAllTvStations() {
      this.selectedTvStations = []
      this.params.tvStations = null
      this.filterBroadcasts()
    },
    onBroadcastStateCheckboxChanged(item) {
      const state = this.params.state === '' ? [] : this.params.state.split(',')
      if (item.checked) {
        item.checked = false
        const index = state.indexOf(String(item.value))
        if (index > -1) {
          state.splice(index, 1)
        }
        this.params.state = state.length > 1 ? state.join(',') : state.length === 1 ? state[0] : ''
      } else {
        item.checked = true
        state.push(item.value)
        this.params.state = state.length > 1 ? state.join(',') : state[0]
      }
      this.filterBroadcasts()
    },
    onFormatChange() {
      this.params.label = this.getLabelRequestFilter()
      this.filterBroadcasts()
    },
    getLabelRequestFilter() {
      return Object.keys(this.formatLabelsState).reduce((result, labelId) => {
        if (this.formatLabelsState[labelId].checked) {
          result.push(labelId)
        }

        return result
      }, []).join(',')
    },
    closesAssignBroadcastPopup() {
      this.assignBroadcastPopupShown = false
    },
    seeAllTvStations() {
      this.seeAllTvStationsShown = true
    },
    closeSeeAllTvStations() {
      this.seeAllTvStationsShown = false
    },
    setSelectedTvStations(tvStations) {
      this.seeAllTvStationsShown = false
      this.selectedTvStations = tvStations
      this.filterBroadcasts()
    }
  },
  watch: {
    createdSelect() {
      this.params.createdBy = this.createdSelect
      this.filterBroadcasts()
    },
    currentTimestamp(date) {
      this.params.fromTimestamp = moment(this.currentTimestamp).startOf('hour').format('X')
      this.filterBroadcasts()
    },
    currentToTimestamp(date) {
      this.params.toTimestamp = moment(this.currentToTimestamp).startOf('hour').format('X')
      this.filterBroadcasts()
    },
    tvStations() {
      if (this.params.tvStations) {
        const tvStationFilterIds = this.params.tvStations.split(',')

        this.selectedTvStations = this.tvStations.filter((tvStation) => {
          return tvStationFilterIds.includes('' + tvStation._id)
        })
      }
    },
    currentLanguageId() {
      this.getLabels({ params: { idLanguage: this.currentLanguageId } })
    },
    items() {
      if (this.selectedAll) {
        this.selectAll(true)
        this.selectedAll = false
      }
    },
    fulltextSearch(value) {
      this.params.fulltextSearch = value
      this.filterBroadcasts()
    }
  }
}
</script>
